import React, { useEffect, useState, useMemo } from 'react';
import {
  Typography, Paper, Table, TableHead, TableRow,
  TableCell, TableBody, Checkbox, Chip, Box, Snackbar, Alert
} from '@mui/material';
import { useParams } from 'react-router-dom';
import API_URL from '../../settings';
import { useAuth } from '../../context/AuthContext';

function EventDetail() {
  const { id } = useParams();
  const [list, setList] = useState([]);
  const { user } = useAuth();

  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    fetch(`${API_URL}/event_recipients?event_id=${id}`)
      .then(res => res.json())
      .then(setList);
  }, [id]);

  const summary = useMemo(() => {
    const received = list.filter(l => l.received).length;
    return {
      received,
      pending: list.length - received
    };
  }, [list]);

  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setToastOpen(false);
  };

  const toggleReceive = async (row) => {
    try {
      // แก้ไข URL ให้ถูกต้องและส่งเฉพาะ PATCH request ไปยัง Resource ID
      const eventRecipientsUrl = `${API_URL}/event_recipients/${row.id}`;

      await fetch(eventRecipientsUrl, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          received: !row.received,
          received_at: !row.received ? new Date().toISOString() : null
        })
      });

      setList(prev =>
        prev.map(r => r.id === row.id ? { ...r, received: !r.received } : r)
      );

      setToastMessage('ปรับสถานะการรับของสำเร็จ');
      setToastOpen(true);
    } catch (error) {
      console.error(error);
      setToastMessage('เกิดข้อผิดพลาดในการปรับสถานะ');
      setToastOpen(true);
    }
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h4" fontWeight="bold">
        รายชื่อผู้รับของ
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, my: 2 }}>
        <Chip color="success" label={`รับแล้ว ${summary.received}`} />
        <Chip color="warning" label={`ยังไม่ได้รับ ${summary.pending}`} />
      </Box>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ชื่อผู้สูงอายุ</TableCell>
            <TableCell align="center">สถานะ</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {list.map(r => (
            <TableRow key={r.id}>
              <TableCell>{r.patient_name}</TableCell>
              <TableCell align="center">
                <Checkbox
                  checked={r.received}
                  onChange={() => toggleReceive(r)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Snackbar open={toastOpen} autoHideDuration={3000} onClose={handleCloseToast} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={handleCloseToast} severity="success" sx={{ width: '100%' }}>
          {toastMessage}
        </Alert>
      </Snackbar>
    </Paper>
  );
}

export default EventDetail;
